module.exports = __webpack_public_path__ + "static/media/screen-noNotch.ef324971.svg";